// extracted by mini-css-extract-plugin
export default {"documentation":"Documentation_documentation__MEl+s"};